import { render } from "./VendorCarsCreate.vue?vue&type=template&id=81f09648"
import script from "./VendorCarsCreate.vue?vue&type=script&lang=js"
export * from "./VendorCarsCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__